// extracted by mini-css-extract-plugin
export default {"phoneList":"PhoneList_phoneList__zluYb","item":"PhoneList_item__NAdkK"};